export const environment = {
  production: false,
  serverUrl: 'https://api-dev.alt-pay.in',
  // serverUrl : 'https://alt-pay-app-dev-be.gazoole.co.in';

};
